module.exports = __webpack_public_path__ + "fonts/fa-regular-400.8a8d8cd6.woff";